<template>
  <div>
    <mu-stepper :activeStep="4">
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabYou')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabHealth')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabLocation')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabGoals')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabPersonalise')}}
        </mu-step-label>
      </mu-step>
    </mu-stepper>
    <mu-card align="left">
      <div v-if="isLoading">
        <mu-card-text align="center">
          <img src="static/Dashboard.gif" width="25%"/>
          <br/>
         {{$t('message.loadingText')}}
        </mu-card-text>
      </div>
      <div v-show="!isLoading">
        <mu-card-header
          :title="title"
          :subTitle="subTitle"
        ></mu-card-header>
        <mu-card-text class="noPaddingBottom">
          <mu-row>
            <mu-col desktop="70" tablet="100" width="100">
              <mu-row gutter>
                <mu-col desktop="50" tablet="50" width="100">
                  <mu-select-field
                    id="ethnicityTxt"
                    autoWidth
                    v-validate
                    :scroller="scroller"
                    :data-vv-rules="'required'"
                    data-vv-name="ethnicity"
                    data-vv-value-path="inputValue"
                    data-vv-as="ethnicity"
                    :errorText="errors.first('ethnicity')"
                    :underlineShow="underlineShow"
                    :fullWidth="fullWidth"
                    :maxHeight="300"
                    :hintText="$t('message.accountPreferencesEthnicity')"
                    v-model="model.ethnicity_id"
                    :label="$t('message.accountPreferencesEthnicity')">
                    <mu-menu-item
                      v-for="item, index in lists.ethnicities"
                      :key="'ethnicity-' + index"
                      :title="$t(localizeEthnicity(item.ethnicity_id))"
                      :value="item.ethnicity_id"
                    >
                    </mu-menu-item>
                  </mu-select-field>
                </mu-col>
                <mu-col desktop="50" tablet="50" width="100">
                  <mu-select-field
                    id="languageTxt"
                    autoWidth
                    v-validate
                    :scroller="scroller"
                    :data-vv-rules="'required'"
                    data-vv-name="language"
                    data-vv-value-path="inputValue"
                    data-vv-as="language"
                    :errorText="errors.first('language')"
                    :underlineShow="underlineShow"
                    :fullWidth="fullWidth"
                    :maxHeight="300"
                    :hintText="$t('message.selectText')"
                    v-model="model.language_id"
                    :label="$t('message.accountPreferencesLanguage')">
                    <mu-menu-item
                      v-for="item, index in lists.languages"
                      :key="'language-' +index"
                      :value="item.id"
                      :title="getNativeName(item.iso)"
                    >
                    </mu-menu-item>
                  </mu-select-field>
                </mu-col>
              </mu-row>
              <mu-select-field
                id="occupationTxt"
                autoWidth
                v-validate
                :scroller="scroller"
                :data-vv-rules="'required'"
                data-vv-name="occupation"
                data-vv-value-path="inputValue"
                :data-vv-as="$t('message.accountPreferencesOccupation')"
                :errorText="errors.first('occupation')"
                :underlineShow="underlineShow"
                :fullWidth="fullWidth"
                :maxHeight="300"
                hintText="Select"
                v-model="model.occupation_id"
                :label="$t('message.accountPreferencesOccupation')">
                <mu-menu-item
                  v-for="item, index in lists.occupations"
                  :key="'occupatation-' + index"
                  :value="item.occupation_id"
                  :title="localizeOccupation(item.occupation_name)"
                >
                </mu-menu-item>
              </mu-select-field>
            </mu-col>
          </mu-row>
          <div class="dashedBorder"></div>
        </mu-card-text>
        <mu-card-header
          class="noPaddingTop"
          :title="$t('message.gettingStartedPersonalizeFoodsTitle')"
          :subTitle="$t('message.gettingStartedPersonalizeFoodsSubTitle')"
        ></mu-card-header>
        <mu-card-text style="padding-bottom: 0px;">
          <mu-row>
            <mu-col desktop="70" tablet="100" width="100">
              <div id="favouriteSearch" style="position: relative">
                <mu-auto-complete
                  id="searchFoodTxt"
                  :scroller="scroller"
                  style="margin-bottom:0px;"
                  :fullWidth="fullWidth"
                  filter="noFilter"
                  v-model="favouriteSearch"
                  :hintText="$t('message.labelStartTyping')"
                  :maxHeight="250"
                  :openOnFocus="true"
                  @change="handleFavouriteSelected"
                  :dataSource="favouriteDataSource"
                  :dataSourceConfig="foodDataSourceConfig"
                  icon="search"
                ></mu-auto-complete>

                <mu-circular-progress v-if="foodSearching"
                                      style="position: absolute;top: 0px;right: 0px;height: 16px;width: 16px;"
                                      :size="16"></mu-circular-progress>

                <mu-chip
                  v-for="item, index in favouriteModel"
                  :key="'favorite-' + index">
                  <mu-icon value="delete" @click.native="favouriteModel.splice(index, 1)"></mu-icon>
                  {{item.food_name}}
                </mu-chip>
              </div>
            </mu-col>
          </mu-row>
          <div class="dashedBorder"></div>
        </mu-card-text>
        <mu-card-header
          class="noPaddingTop"
          :title="$t('message.gettingStartedPersonalizeDietaryPreferencesTitle')"
          :subTitle="$t('message.gettingStartedPersonalizeDietaryPreferencesSubTitle')"></mu-card-header>
        <mu-card-text v-show="!isLoading" class="noPaddingBottom">
          <mu-row gutter>
            <mu-col width="100" desktop="70" tablet="100">
              <mu-row>
                <mu-col desktop="50" tablet="50" width="100">
                  <mu-select-field
                    id="dietaryPreferenceTxt"
                    :scroller="scroller"
                    autoWidth
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="dietry_preference"
                    data-vv-value-path="inputValue"
                    :data-vv-as="$t('message.accountPreferencesDietaryPreference')"
                    :errorText="errors.first('dietry_preference')"
                    :underlineShow="underlineShow"
                    :fullWidth="fullWidth"
                    :maxHeight="370"
                    :hintText="$t('message.selectText')"
                    v-model="model.dietry_preference_id"
                    :label="$t('message.accountPreferencesDietaryPreference')">
                    <mu-menu-item
                      v-for="item, index in lists.dietry_preferences"
                      :key="'dietary-preference-' + index"
                      :value="item.dietry_preference_id"
                      :title="localizeDietPreference(item.name)"
                    >
                    </mu-menu-item>
                  </mu-select-field>
                </mu-col>
                <mu-col desktop="50" tablet="50" width="100">
                  <mu-select-field
                    id="allergiesTxt"
                    :scroller="scroller"
                    multiple
                    separator=", "
                    v-model="model.allergies"
                    autoWidth
                    :fullWidth="fullWidth"
                    :maxHeight="370"
                    :hintText="$t('message.selectText')"
                    :label="$t('message.accountPreferencesAllergies')">
                    <mu-menu-item
                      v-for="item, index in lists.allergies"
                      :key="'allergy-' + index"
                      :value="item.allergy_id"
                      :title="localizeAllergy(item.name)"
                    >
                    </mu-menu-item>
                  </mu-select-field>
                </mu-col>
                <mu-col width="100" desktop="50" tablet="50">
                  <currency-input
                    v-if="currency.currency"
                    :label="$t('message.accountPreferencesShopCost')"
                    v-model.number="model.weekly_shop_cost"
                    :currency="currency.currency"
                  ></currency-input>
                </mu-col>
              </mu-row>
            </mu-col>
          </mu-row>
          <mu-row>

          </mu-row>
          <div class="dashedBorder"></div>
        </mu-card-text>
        <mu-card-header
          class="noPaddingTop"
          :title="$t('message.gettingStartedPersonalizeHealthTitle')"
          :subTitle="$t('message.gettingStartedPersonalizeHealthSubTitle')"
        >
        </mu-card-header>
        <mu-card-text>
          <mu-row gutter>
            <mu-col desktop="70" tablet="100" width="100">
              <mu-col desktop="100" width="100" tablet="100"></mu-col>
              <mu-col desktop="100" width="100" tablet="100">
                <mu-row gutter v-if="settings.hba1c && isDiabetic">
                  <mu-col width="70" desktop="70" tablet="70">
                    <mu-text-field
                      id="hba1cPercentTxt"
                      v-validate
                      data-vv-name="hba1c_percent"
                      :data-vv-rules="'min_value:3|max_value:25'"
                      data-vv-value-path="inputValue"
                      data-vv-as="HbA1c"
                      :errorText="errors.first('hba1c_percent')"
                      type="number"
                      :hintText="$t('message.placeholderText')"
                      v-show="activeHba1cType.measure === 'percentage'"
                      v-model.number="hba1cModel.percent"
                      :fullWidth="fullWidth"
                      label="HbA1c"
                    />
                    <mu-text-field
                      id="hba1cMmolmolTxt"
                      v-validate
                      data-vv-name="hba1c_mmol_mol"
                      :data-vv-rules="'min_value:8|max_value:300'"
                      data-vv-value-path="inputValue"
                      data-vv-as="HbA1c"
                      :errorText="errors.first('hba1c_mmol_mol')"
                      type="number"
                      :hintText="$t('message.placeholderText')"
                      v-show="activeHba1cType.measure === 'mmol-mol'"
                      v-model.number="hba1cModel.mmol_mol"
                      :fullWidth="fullWidth"
                      label="HbA1c"
                    />
                  </mu-col>
                  <mu-col width="30" desktop="30" tablet="30">
                    <mu-select-field
                      id="hba1cSettingTxt"
                      autoWidth
                      v-validate
                      data-vv-name="hba1c"
                      data-vv-value-path="inputValue"
                      data-vv-as="HbA1c"
                      :errorText="errors.first('hba1c')"
                      :underlineShow="underlineShow"
                      :fullWidth="fullWidth"
                      hintText="Select"
                      v-model="settingsModel.hba1c"
                      :label="' '">
                      <mu-menu-item
                        v-for="item, index in settings.hba1c.dropdown"
                        :key="'hba1c-dropdown-' + index"
                        :value="item.preference_id"
                        :title="item.unit"
                      >
                      </mu-menu-item>
                    </mu-select-field>
                  </mu-col>
                </mu-row>

                <mu-row desktop="100" width="100" tablet="100" v-if="isDiabetic">
                  <mu-select-field
                    id="hba1cEvaluationTxt"
                    autoWidth
                    v-validate
                    data-vv-name="hba1c_month_id"
                    data-vv-value-path="inputValue"
                    data-vv-as="HbA1c evaluation"
                    autoWidth
                    :errorText="errors.first('hba1c_month_id')"
                    :underlineShow="underlineShow"
                    :fullWidth="fullWidth"
                    :label="$t('message.labelLastHbA1c')" :hintText="$t('message.placeholderText')" v-model="model.hba1c_month_id"
                    fullWidth>
                    <mu-menu-item v-for="item, index in lists.hba1c_months" :value="item.id"
                                  :key="'hba1c-month-' + index"
                                  :title="item.name"></mu-menu-item>
                  </mu-select-field>
                </mu-row>
                <mu-row gutter v-if="settings.height">
                  <mu-col width="70" desktop="70" tablet="70">
                    <mu-row v-show="settingsModel.height === 1">
                      <mu-col width="50" desktop="50" tablet="50">
                        <mu-text-field
                          id="heightFtTxt"
                          v-if="settingsModel.height === 1"
                          v-validate="'required|min_value:0|max_value:8'"
                          data-vv-value-path="inputValue"
                          data-vv-name="height_ft"
                          data-vv-as="ft"
                          :errorText="errors.first('height_ft')"
                          :min="0"
                          :max="8"
                          v-model.number="heightModel.ft"
                          :hintText="$t('message.placeholderText')"
                          helpText="FT"
                          :label="$t('message.labelHeight')"
                          type="number"
                          fullWidth
                        ></mu-text-field>
                      </mu-col>
                      <mu-col width="50" desktop="50" tablet="50">
                        <mu-text-field
                          id="heightInTxt"
                          v-if="settingsModel.height === 1"
                          v-validate="'required|min_value:0|max_value:11'"
                          data-vv-value-path="inputValue"
                          data-vv-name="height_in"
                          data-vv-as="in"
                          :errorText="errors.first('height_in')"
                          :min="0"
                          :max="11"
                          v-model.number="heightModel.in"
                          :hintText="$t('message.placeholderText')"
                          helpText="IN"
                          label=" "
                          type="number"
                          fullWidth
                        ></mu-text-field>
                      </mu-col>
                    </mu-row>
                    <mu-row v-show="settingsModel.height === 2">
                      <mu-col width="100" desktop="100" tablet="100">
                        <mu-text-field
                          id="heightCmTxt"
                          v-if="settingsModel.height === 2"
                          v-validate="'required|min_value:50|max_value:251'"
                          data-vv-name="height_cm"
                          data-vv-value-path="inputValue"
                          data-vv-as="cm"
                          :errorText="errors.first('height_cm')"
                          label="Height"
                          :hintText="$t('message.placeholderText')"
                          v-model.number="heightModel.cm"
                          :fullWidth="fullWidth"
                          type="number"
                        />
                      </mu-col>
                    </mu-row>
                  </mu-col>
                  <mu-col width="30" desktop="30" tablet="30">
                    <mu-select-field
                      id="heightSettingsTxt"
                      autoWidth
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="height"
                      data-vv-value-path="inputValue"
                      data-vv-as="height"
                      :errorText="errors.first('height')"
                      :underlineShow="underlineShow"
                      :fullWidth="fullWidth"
                      :maxHeight="370"
                      hintText="Select"
                      v-model="settingsModel.height"
                      :label="' '">
                      <mu-menu-item
                        v-for="item, index in settings.height.dropdown"
                        :key="'height-dropdown-' + index"
                        :value="item.preference_id"
                        :title="item.unit"
                      >
                      </mu-menu-item>
                    </mu-select-field>
                  </mu-col>
                </mu-row>

                <mu-row gutter v-if="settings.weight">
                  <mu-col width="70" desktop="70" tablet="70">
                    <mu-row v-if="settingsModel.weight === 1" gutter>
                      <mu-text-field
                        id="weightKgTxt"
                        :min="20"
                        :max="750"
                        v-validate
                        :data-vv-rules="'required|min_value:20|max_value:635'"
                        data-vv-name="weight_kg"
                        data-vv-value-path="inputValue"
                        data-vv-as="kg"
                        :errorText="errors.first('weight_kg')"
                        :underlineShow="underlineShow"
                        :fullWidth="fullWidth"
                        :hintText="$t('message.selectText')"
                        :label="$t('message.cardWeight')"
                        type="number"
                        v-model.number="weightModel.kg"
                      />
                    </mu-row>
                    <mu-row v-if="settingsModel.weight === 2" gutter>
                      <mu-text-field
                        id="weightLbsTxt"
                        :min="0"
                        :max="1102"
                        v-validate
                        :data-vv-rules="'required|min_value:20|max_value:1400'"
                        data-vv-name="weight_lbs"
                        data-vv-value-path="inputValue"
                        data-vv-as="lbs"
                        :errorText="errors.first('weight_lbs')"
                        :label="$t('message.cardWeight')"
                        type="number"
                        :hintText="$t('message.placeholderText')"
                        v-model.number="weightModel.lbs"
                        :fullWidth="fullWidth"
                      />
                    </mu-row>
                    <mu-row v-if="settingsModel.weight === 3" gutter>
                      <mu-col desktop="50" width="50" tablet="50">
                        <mu-text-field
                          id="weightStonesTxt"
                          :min="0"
                          :max="92"
                          v-validate
                          :data-vv-rules="'required|min_value:0|max_value:92'"
                          data-vv-name="stones"
                          data-vv-value-path="inputValue"
                          data-vv-as="stones"
                          :errorText="errors.first('stones')"
                          :label="$t('message.cardWeight')"
                          type="number"
                          :hintText="$t('message.placeholderText')"
                          helpText="ST"
                          v-model.number="weightModel.stones"
                          :fullWidth="fullWidth"
                        />
                      </mu-col>
                      <mu-col desktop="50" width="50" tablet="50">
                        <mu-text-field
                          id="weightPoundsTxt"
                          :min="0"
                          :max="13"
                          v-validate
                          :data-vv-rules="'required|min_value:0|max_value:13'"
                          data-vv-name="pounds"
                          data-vv-value-path="inputValue"
                          data-vv-as="pounds"
                          :errorText="errors.first('pounds')"
                          label=" "
                          helpText="LBS"
                          type="number"
                          :hintText="$t('message.placeholderText')"
                          v-model.number="weightModel.pounds"
                          :fullWidth="fullWidth"
                        />
                      </mu-col>
                    </mu-row>
                  </mu-col>
                  <mu-col width="30" desktop="30" tablet="30">
                    <mu-select-field
                      id="weightSettingsTxt"
                      autoWidth
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="weight"
                      data-vv-value-path="inputValue"
                      data-vv-as="weight"
                      :errorText="errors.first('weight')"
                      :underlineShow="underlineShow"
                      :fullWidth="fullWidth"
                      :maxHeight="370"
                      :hintText="$t('message.selectText')"
                      v-model="settingsModel.weight"
                      :label="' '">
                      <mu-menu-item
                        v-for="item, index in settings.weight.dropdown"
                        :key="'weight-dropdown-' + index"
                        :value="item.preference_id"
                        :title="item.unit"
                      >
                      </mu-menu-item>
                    </mu-select-field>
                  </mu-col>
                </mu-row>
              </mu-col>
              <mu-col desktop="100" width="100" tablet="100"></mu-col>
            </mu-col>
          </mu-row>
        </mu-card-text>
        <mu-card-actions align="center">
          <mu-raised-button
            :fullWidth="true"
            secondary
            :disabled="isSaving"
            @click.native="submitForm"
            :label="isSaving ? $t('message.savingText'):$t('message.nextText')"></mu-raised-button>
        </mu-card-actions>
      </div>
    </mu-card>
  </div>
</template>
<script>

  import AccountApi from '../../api/Account'
  import GeoApi from '../../api/Geo'
  import SettingsApi from '../../api/Settings'
  import TrackingApi from '../../api/Tracking'
  import FoodApi from '../../api/Food'
  import UserManager from '../../helpers/UserManager'
  import UserApi from '../../api/User'
  import ScrollerMixin from '../../mixins/ScrollerMixin'
  import AllergyLocalizerMixin from '../../mixins/Localization/Allergies'
  import DietPreferenceLocalizerMixin from '../../mixins/Localization/DietaryPreferences'
  import OccupationLocalizerMixin from '../../mixins/Localization/Occupations'
  import EthnicityLocalizerMixin from '../../mixins/Localization/Ethnicity'

  import {getLanguageNativeName, getLanguageName} from '../../mixins/Localization/Languages'




  import {Observable} from 'rxjs/Rx'



  import CountryJs from 'country-js'
  import CurrencyInput from '../../directives/CurrencyInput'

  import Config from '../../config';
  import axios from 'axios';
  import {sha256} from "js-sha256";


  export default {
    mixins: [ScrollerMixin, AllergyLocalizerMixin, OccupationLocalizerMixin, DietPreferenceLocalizerMixin, EthnicityLocalizerMixin],
    components: {
      CurrencyInput
    },
    name: 'personalise',
    data() {
      return {
        user_id: null,
        title: this.$t('message.gettingStartedPersonalizeTitle'),
        subTitle: this.$t('message.gettingStartedPersonalizeSubTitle'),
        allergySearch: '',
        favouriteSearch: '',
        activeDiabetesType: {},
        activeHba1cMonth: {},
        activeHba1cType: {},
        foodSearching: false,
        isLoading: true,
        isSaving: false,
        isDiabetic: true,
        activeStep: 4,
        fullWidth: true,
        underlineShow: true,
        model: {
          diabetes_type_id: null,
          weekly_shop_cost: 53.20,
          currency_code: '',
          dietry_preference_id: null,
          allergies: [],
          hba1c_month_id: 1
        },
        lists: {},
        currency: {},
        settings: {},
        settingsModel: {
          blood_glucose: null,
          hba1c: null,
          height: null
        },
        bloodGlucoseModel: {
          blood_glucose_mgdl: null,
          blood_glucose_mmoll: null
        },
        heightModel: {
          ft: null,
          in: null,
          cm: null
        },
        hba1cModel: {
          percent: null,
          mmol_mol: null,
          date: ''
        },
        weightModel: {
          kg: null,
          lbs: null,
          stones: null,
          pounds: null
        },
        allergyDataSource: [],
        favouriteDataSource: [],
        allergyModel: [],
        favouriteModel: [],
        foodDataSourceConfig: {
          text: 'food_name',
          value: 'food_id',
        },
        allergies: []
      }
    },
    watch: {
      'settingsModel.hba1c': function () {
        let self = this;
        self.activeHba1cType = self.settings.hba1c.dropdown.filter(function (item) {
          return item.preference_id === self.settingsModel.hba1c
        })[0];
        self.hba1cModel = {
          percent: null,
          mmol_mol: null,
          date: ''
        }
      },
      'settingsModel.weight': function () {
        let self = this;
        self.weightModel = {
          kg: null,
          lbs: null,
          stones: null,
          pounds: null
        }
      },
      'settingsModel.blood_glucose': function () {
        let self = this;
        self.bloodGlucoseModel = {
          blood_glucose_mgdl: null,
          blood_glucose_mmoll: null
        };
        self.$forceUpdate()
      },
      'settingsModel.height': function () {
        let self = this;
        self.heightModel = {
          ft: null,
          in: null,
          cm: null
        }
        self.$forceUpdate();
      },
      'heightModel.cm': function () {
        let self = this;
        if (self.heightModel.cm === '') {
          self.heightModel.cm = null
        }
      },
      'heightModel.ft': function () {
        let self = this;
        if (self.heightModel.ft === '') {
          self.heightModel.ft = null
        }

      },
      'heightModel.in': function () {
        let self = this;
        if (self.heightModel.in === '') {
          self.heightModel.in = null
        }
      },
      'weightModel.kg': function () {
        let self = this;
        if (self.weightModel.kg === '') {
          self.weightModel.kg = null
        }
      },
      'weightModel.lbs': function () {
        let self = this;
        if (self.weightModel.lbs === '') {
          self.weightModel.lbs = null
        }
      },
      'weightModel.stones': function () {
        let self = this;
        if (self.weightModel.stones === '') {
          self.weightModel.stones = null
        }
      },
      'weightModel.pounds': function () {
        let self = this;
        if (self.weightModel.pounds === '') {
          self.weightModel.pounds = null
        }
      },
      'model.weekly_shop_cost': function () {
        let self = this;
        self.$forceUpdate()
      },
      '$route': function () {
        let self = this;
        self.initPersonalisation();
      }
    },

    mounted() {
      let self = this;
      self.$gtag.pageview('/getting-started/personalise');
      self.initPersonalisation();
    },
    updated() {
      let self = this;



      // self.initPersonalisation();
    },

    methods: {
      getNativeName(key) {
        return getLanguageNativeName(key);
      },
      updateCommuicator() {
        let self = this;
        axios.get(Config.apiUrl + 'user/updateComm/' + self.user_id);
        axios.get(Config.apiUrl + 'user/sendEmail');
      },
      initPersonalisation() {
        let self = this;
        /**
         * RxJs favourite observable, wait 150ms before calling server and wait for distict change
         * @type {*}
         */
        const favouriteAutoCompleteElement = $('#favouriteSearch .mu-auto-complete .mu-text-field-input');
        const observableFavourite = Observable.fromEvent(favouriteAutoCompleteElement, 'keydown').map(x => x.currentTarget.value);
        const debouncedFavourite = observableFavourite.debounceTime(250).distinctUntilChanged();
        debouncedFavourite.subscribe(function (eventText) {
          self.handleFoodSearch(self.favouriteSearch, 'favourite');
        }.bind(self));

        UserApi.getFavouriteFoods()
          .then(function (response) {
            self.favouriteModel = response.data
          });

        self.lists = self.$store.state.list;
        AccountApi.getAccount()
          .then(function (response) {
            self.user_id = response.data.user_id;
            self.model.country_id = null;
            self.model.diabetes_type_id = response.data.diabetes_type_id
            self.model.postcode = response.data.postcode_zip
            self.model.language_id = 1;
            self.model.weekly_shop_cost = 52.20;
            if (self.model.diabetes_type_id === 0) {
              self.model.diabetes_type_id = null
            }

            const diabetesType = self.$store.state.list.diabetes_types.filter(function (item) {
              return item.diabetes_type_id === response.data.diabetes_type_id;
            })[0];

            self.activeDiabetesType = diabetesType;
            if (_.has(self.activeDiabetesType, 'is_diabetic')) {
              if (self.activeDiabetesType.is_diabetic === true) {
                self.isDiabetic = true;
              }
              else {
                self.isDiabetic = false;
              }
            }

            AccountApi.getUserPersonalization()
              .then(function (response) {
                if (response.data !== false) {
                  self.model = response.data;
                  self.model.weekly_shop_cost = 52.50;
                  if (self.model.dietry_preference_id === null) {
                    self.model.dietry_preference_id = 1;
                  }
                  if (self.model.dietry_preference === undefined) {
                    self.model.dietry_preference_id = 1;
                  }
                  if (self.model.language_id === undefined) {
                    self.model.language_id = 1
                  }
                  self.$forceUpdate();
                }
              });
            SettingsApi.getSettings().then(function (response) {
              self.settings = response.data;
              GeoApi.geoIp().then(function (response) {
                if (_.has(response.data, 'host') && (response.data.country_id !== 0)) {
                  let country = response.data.host.country, country_id = response.data.country_id,
                    countriesFound = CountryJs.search(country);
                  self.determineSettingsFromCountryOrCurrentSettings(country_id);
                  if (countriesFound.length >= 0) {
                    self.currency = countriesFound[0];
                    self.isLoading = false
                  }


                }
                else {
                  let country = 'UK', country_id = 235, countriesFound = CountryJs.search(country);
                  self.determineSettingsFromCountryOrCurrentSettings(235);
                  self.currency = countriesFound[0];
                  self.isLoading = false
                }
              })
            });
            self.$nextTick(function () {
              self.errors.clear()
            })
          })
      },
      triggerGaEvent() {
        let self = this;
        self.$gtag.event('PersonalisePanelComplete', {
          'event_category': 'Onboarding',
          'event_label': 'Completed personalise panel',
          'value': 1
        });
        self.$gtag.event( 'OnboardingComplete', {
          'event_category': 'Registration',
          'event_label': 'Completed onboarding/personalization process',
          'value': 1
        });
      },
      handleFavouriteSelected(value) {
        let self = this;
        let checkExists = self.favouriteModel.filter(function (item) {
          return item.food_name === value;
        });
        if (checkExists.length === 0) {
          let object = self.favouriteDataSource.filter(function (item) {
            return item.food_name === value
          })[0];
          self.favouriteModel.push(object);
          self.$nextTick(function () {
            self.favouriteSearch = '';
          })
        }
        else {
          self.$nextTick(function () {
            self.favouriteSearch = '';
          })
        }
      },
      handleFoodSearch(value, type) {
        let self = this;
        if (type === 'favourite') {


          self.foodSearching = true;
          FoodApi.autoComplete(value)
            .then(function (response) {

              let items = [];

              let itemLength = response.data.length;

              if (_.isArray(response.data)) {
                for (let i = 0; i < itemLength; i++) {
                  let model = {
                    food_id: 0,
                    food_name: response.data[i]
                  };
                  items.push(model);
                }
                self.favouriteDataSource = items;
                self.foodSearching = false;
                self.$nextTick(function () {
                  self.favouriteDataSource = items.sort(function (a, b) {
                    return a.food_name.toLowerCase() > value.toLowerCase()
                  })
                });
              }
            });
        }
      },
      weightQualifier() {
        let self = this;
        if (self.weightModel.kg !== null) {
          return true
        }
        if (self.weightModel.lbs !== null) {
          return true
        }
        if (self.weightModel.stones !== null && self.weightModel.pounds !== null) {
          return true
        }
        return false
      },
      heightQualifier() {
        let self = this;
        if (self.heightModel.cm !== null || (self.heightModel.ft !== null && self.heightModel.in)) {
          return true
        }
        return false
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              let fbCompleteRegModel = {
                "data": [
                  {
                    "event_name": "CompleteRegistration",
                    "event_time": moment().unix(),
                    "action_source": "email",
                    "user_data": {
                      "em": sha256(self.$store.state.user.scope.email),
                      "client_ip_address": self.$store.state.geoLocation.host.ip,
                      "client_user_agent": navigator.userAgent
                    },
                  }
                ]
              }
              axios.post('https://graph.facebook.com/v11.0/625160948457652/events?access_token=EAALxgEaGHOQBAPhSgGaAn8wfcfGUmKNrCk6cpoQO7NX85wxgmaD56HgMmGQLUEKMPsyCAFgMuh33vl8r1go8uO1xHgCoM3y9Ggkm2JejlIX6jeoCEW3GnA9V9N6FMInLHjSh9lzKmaEAIacBfG0o4NUqUcdolpi4frbZCh8VQU1qPtpK30wSj3VbxTKQZD', fbCompleteRegModel)
                .then((res) => {
                })
                .catch((res) => {
                })

              self.isSaving = true;
              self.model.currency_code = self.currency.currency.currencyCode;
              self.$forceUpdate();
              UserApi.putFavouriteFoods(self.favouriteModel)
                .then(function (response) {
                  if (self.heightQualifier()) {
                    SettingsApi.updateHeightSettings(self.heightModel)
                      .then(function (response) {
                        self.doPost()
                      })
                  }
                  else {
                    self.doPost()
                  }
                })
                .catch(function (error) {
                  if (self.heightQualifier()) {
                    SettingsApi.updateHeightSettings(self.heightModel)
                      .then(function (response) {
                        self.doPost()
                      })
                  }
                  else {
                    self.doPost()
                  }
                })
            }
          })
      },
      doPost() {
        let self = this;
        if (self.isDiabetic === true) {
          if (self.model.hba1c_month_id !== null) {
            self.activeHba1cMonth = self.lists.hba1c_months.filter(function (item) {
              return item.id === self.model.hba1c_month_id
            })[0];
            if (_.has(self.activeHba1cMonth, 'days')) {
              let days = self.activeHba1cMonth.days;
              let date = moment();
              date.subtract(days, 'day');
              self.hba1cModel.date = date.format('YYYY-MM-DD HH:MM')
            }
          }
        }
        AccountApi.putUserPersonalization(self.model).then(function (response) {


          self.triggerGaEvent();

          UserApi.onBoardingStatus()
            .then(function (response) {
              self.$store.commit('setOnBoardingStatus', response.data);
              SettingsApi.putSettings(self.settingsModel).then(function (response) {
                UserManager.getUserAndStore(self);
                self.$forceUpdate();
                TrackingApi.postHba1cReading(self.hba1cModel)
                  .then(function (response) {
                    if (self.weightQualifier()) {
                      TrackingApi.postWeightReading(self.weightModel)
                        .then(function (response) {
                          self.updateCommuicator();
                          self.$router.push({
                            name: 'Dashboard'
                          })
                        })
                        .catch(function (error) {
                          self.updateCommuicator();
                          self.$router.push({
                            name: 'Dashboard'
                          })
                        })
                    }
                    else {
                      self.updateCommuicator();
                      self.$router.push({
                        name: 'Dashboard'
                      });
                    }
                  })
                  .catch(function (error) {
                    self.updateCommuicator();
                    self.$router.push({
                      name: 'Dashboard'
                    })
                  })
              })

            });


        })
      },
      determineSettingsFromCountryOrCurrentSettings(country_id) {
        let self = this;
        SettingsApi.getUnitSettings()
          .then(function (response) {
            if (response.data.blood_glucose !== null) {
              self.settingsModel = response.data
            }
            else {
              switch (country_id) {
                case 237:
                  //United States of Ameria
                  self.settingsModel = {
                    blood_glucose: 1,
                    hba1c: 1,
                    weight: 3,
                    waist: 1,
                    height: 2
                  };
                  break;
                case 126:
                  //Liberia
                  self.settingsModel = {
                    blood_glucose: 1,
                    hba1c: 1,
                    weight: 3,
                    waist: 1,
                    height: 2
                  };
                  break;
                case 153:
                  //Myanmar
                  self.settingsModel = {
                    blood_glucose: 1,
                    hba1c: 1,
                    weight: 3,
                    waist: 1,
                    height: 2
                  };
                  break;
                default:
                  //Europe countries
                  self.settingsModel = {
                    blood_glucose: 2,
                    hba1c: 2,
                    weight: 1,
                    height: 2,
                    waist: 2
                  }
              }
            }
          })
          .catch(function (error) {
            switch (country_id) {
              case 237:
                //United States of Ameria
                self.settingsModel = {
                  blood_glucose: 1,
                  hba1c: 1,
                  weight: 3,
                  waist: 1,
                  height: 2
                };
                break;
              case 126:
                //Liberia
                self.settingsModel = {
                  blood_glucose: 1,
                  hba1c: 1,
                  weight: 3,
                  waist: 1,
                  height: 2
                };
                break;
              case 153:
                //Myanmar
                self.settingsModel = {
                  blood_glucose: 1,
                  hba1c: 1,
                  weight: 3,
                  waist: 1,
                  height: 2
                };
                break;
              default:
                //Europe countries
                self.settingsModel = {
                  blood_glucose: 2,
                  hba1c: 2,
                  weight: 1,
                  height: 2,
                  waist: 2
                }
            }
          })
      },
      /*determineSettingsFromCountryOrCurrentSettings(country_id) {
        let self = this;
        SettingsApi.getUnitSettings()
          .then(function (response) {
            if (response.data.blood_glucose !== null) {
              self.settingsModel = response.data
            }
            else {
              switch (country_id) {
                case 237:
                  //United States of Ameria
                  self.settingsModel = {
                    blood_glucose: 1,
                    hba1c: 1,
                    weight: 3,
                    waist: 1,
                    height: 2
                  };
                  break;
                case 126:
                  //Liberia
                  self.settingsModel = {
                    blood_glucose: 1,
                    weight: 3,
                    hba1c: 1,
                    waist: 1,
                    height: 2
                  };
                  break;
                case 153:
                  //Myanmar
                  self.settingsModel = {
                    blood_glucose: 1,
                    weight: 3,
                    hba1c: 1,
                    waist: 1,
                    height: 2
                  };
                  break;
                default:
                  //Europe countries
                  self.settingsModel = {
                    blood_glucose: 2,
                    hba1c: 2,
                    weight: 1,
                    height: 2,
                    waist: 2
                  }
              }
            }
          })
          .catch(function (error) {
            switch (country_id) {
              case 237:
                //United States of Ameria
                self.settingsModel = {
                  blood_glucose: 1,
                  weight: 3,
                  hba1c: 1,
                  waist: 1,
                  height: 2
                };
                break;
              case 126:
                //Liberia
                self.settingsModel = {
                  blood_glucose: 1,
                  weight: 3,
                  hba1c: 1,
                  waist: 1,
                  height: 2
                };
                break;
              case 153:
                //Myanmar
                self.settingsModel = {
                  blood_glucose: 1,
                  weight: 3,
                  hba1c: 1,
                  waist: 1,
                  height: 2
                };
                break;
              default:
                //Europe countries
                self.settingsModel = {
                  blood_glucose: 2,
                  hba1c: 2,
                  weight: 1,
                  height: 2,
                  waist: 2
                }
            }
          })
      },*/
      forceUpdate() {
        let self = this;
        self.$forceUpdate()
      }
    }
  }
</script>
<style>
  .mu-text-field-help {
    position: static !important;
  }

  .dottedLine {
    width: 100%;
    display: block;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.12);
  }

  .noPaddingTop {
    padding-top: 0px !important;
  }

  .noPaddingBottom {
    padding-bottom: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// Personalise.vue?a5a703e4